import {createSlice} from "@reduxjs/toolkit";

const movieSlice = createSlice({
    name:"movie",
    initialState:{
        nowPlayingMovies:null,
        popularMovie:null,
        topRatedMovies:null,
        upcomingMovies:null,
        singleMovieDetail:null,
        credits: null,
        id:"null",
        trailerMovie:null, 
        open:false,
    },
    reducers:{
        // actions
        getNowPlayingMovies:(state,action)=>{
            state.nowPlayingMovies = action.payload;
        },
        getPopularMovie:(state,action)=>{
            state.popularMovie = action.payload;
        },
        getTopRatedMovie:(state,action)=>{
            state.topRatedMovies = action.payload;
        },
        getUpcomingMovie:(state,action)=>{
            state.upcomingMovies = action.payload;
        },
  
         getsingleMovieDetail:(state,action)=>{
            state.singleMovieDetail = action.payload;
        },
        getcredits:(state,action)=>{
            state.credits = action.payload;
        },
        
        getId:(state,action)=>{
            state.id = action.payload;
        },
        getTrailerMovie:(state,action)=>{
            state.trailerMovie = action.payload;
        },
        setOpen:(state,action)=>{
            state.open = action.payload;
        },
     
    }
});
export const {getNowPlayingMovies,getPopularMovie,getTopRatedMovie,getUpcomingMovie, getsingleMovieDetail, getcredits, getId, getTrailerMovie, setOpen} = movieSlice.actions;
export default movieSlice.reducer;